
import { AdminDashboard, TeacherDashboard } from "../../features/dashboard";
import { getLoggedInUserRole } from "../../modules/common/user/UserService";
import { StudentDashboard } from "../../features/dashboard/student/StudentDashboard";

export const Dashboard = () => {
  const role = getLoggedInUserRole();

  switch (role) {
    case "ROLE_ADMIN":
      return <AdminDashboard />;
    case "ROLE_FACULTY":
      return <TeacherDashboard />;
    case "ROLE_STUDENT":
      return <StudentDashboard />;
    default:
      return <div>No dashboard available</div>;
  }
};
